import type { ReactNode } from "react";
import { useEffect, useState } from "react";

interface PreviewCardProps {
  children: ReactNode;
  animateOnMount?: boolean;
}

export const PreviewCard = ({ children, animateOnMount }: PreviewCardProps) => {
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    if (animateOnMount) setIsAnimated(true);
  }, [animateOnMount]);

  const style = animateOnMount
    ? isAnimated
      ? { animation: "fadeInDownLocal 0.6s ease-out forwards" }
      : { opacity: 0 }
    : undefined;

  return (
    <div className="overflow-hidden rounded-3xl bg-white" style={style}>
      {animateOnMount && (
        <style>{`
          @keyframes fadeInDownLocal {
            0% {
              opacity: 0;
              transform: translateY(-100px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      )}
      {children}
    </div>
  );
};
